import type React from 'react';

import type * as api from '@gitbook/api-client';
import type { NavigationScreenSpaceState } from '@gitbook/app-navigation';
import {
    getAbsolutePagePathInRevision,
    type Revision,
    type RevisionPageDocument,
} from '@gitbook/hive-core';

import { CommentsNavigationProvider, type NavigateToCommentsFn } from '../../../Components';
import { useNavigation } from '../../../navigation';

/**
 * Provide the context for navigating comments in a space.
 */
export function SpaceCommentsNavigation(
    props: React.PropsWithChildren<{
        space: api.Space;
        changeRequest: api.ChangeRequest | undefined;
        revision: Revision;
        page: RevisionPageDocument;
        screen: NavigationScreenSpaceState;
    }>
) {
    const { space, changeRequest, revision, page, screen, children } = props;

    const { navigate } = useNavigation();

    const navigateToComments: NavigateToCommentsFn = (input) => {
        const pagePath = input.pageId
            ? getAbsolutePagePathInRevision(revision, input.pageId)
            : undefined;
        navigate(
            {
                current: {
                    ...(typeof pagePath === 'string' ? { page: pagePath } : {}),
                    sideSheet: input.sideSheet,
                },
            },
            { replace: input.replace }
        );
    };

    return (
        <CommentsNavigationProvider
            spaceId={space.id}
            changeRequestId={changeRequest?.id ?? undefined}
            navigateToComments={navigateToComments}
            currentPageId={page.id}
            currentSideSheet={screen.sideSheet?.type === 'comments' ? screen.sideSheet : undefined}
        >
            {children}
        </CommentsNavigationProvider>
    );
}
